import def from './default';
import school from './operations/school';
import deliveries from './operations/deliveries';
import employee from './operations/employee';
import broker from './operations/broker';

const en = {
  default: def,
  school,
  deliveries,
  employee,
  broker
};

export default en;
